module.exports = __webpack_public_path__ + "img/register3.c89ba408.png";